module.exports = __webpack_public_path__ + "img/goal_m03-1.898be4e8.jpg";